import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
// components
import Header from '@/components/Layout/components/Header';

const Attributes = () => {
    return (
        <>
            <Helmet>
                <title>NEWO - Attributes</title>
            </Helmet>
            <Header breadcrumbs={[{ label: 'Attributes' }]} />
            <Outlet />
        </>
    );
};

export default Attributes;
